import { render } from "./EventMessages.vue?vue&type=template&id=777fb43b"
import script from "./EventMessages.vue?vue&type=script&lang=js"
export * from "./EventMessages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__